module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-popup', {
    attrs: {
      "id": "AccountActivation"
    }
  }, [_c('f7-navbar', [_c('f7-nav-left'), _vm._v(" "), _c('f7-nav-center', {
    staticClass: "titleApp",
    attrs: {
      "sliding": ""
    }
  }), _vm._v(" "), _c('f7-nav-right')], 1), _vm._v(" "), _c('p', {
    staticClass: "displayimg"
  }, [_c('img', {
    staticClass: "h-sm testimg",
    attrs: {
      "id": "companyName",
      "src": require("./../../assets/static/images/CorpMessenger.png")
    }
  })]), _vm._v(" "), _c('f7-card', [_c('f7-card-header', {
    staticClass: "accountActivationCenter"
  }, [_vm._v("Activate Account")]), _vm._v(" "), _c('f7-card-content', {
    staticClass: "accountActivationCenter"
  }, [_c('p', [_vm._v("Please enter your activation code")]), _vm._v(" "), _c('p', [_c('f7-input', {
    staticClass: "accountActivationInput",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.activationCode),
      callback: function($$v) {
        _vm.activationCode = $$v
      },
      expression: "activationCode"
    }
  }), _vm._v(" "), _c('f7-button', {
    staticClass: "blueConfirmationButtonActivationOK button",
    on: {
      "click": function($event) {
        return _vm.activateAccount()
      }
    }
  }, [_vm._v("OK")])], 1)])], 1), _vm._v(" "), _c('f7-button', {
    staticClass: "blueConfirmationButtonActivation button",
    on: {
      "click": function($event) {
        return _vm.sendAnotherCode()
      }
    }
  }, [_vm._v("Send another code")]), _vm._v(" "), _c('f7-button', {
    staticClass: "blueConfirmationButtonActivation button close-popup"
  }, [_vm._v("Back  "), _c('f7-icon', {
    attrs: {
      "size": "14px",
      "f7": "undo"
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62a22065", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62a22065","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/user/CMAccountActivation.vue
// module id = 1681
// module chunks = 2